import { DevEx } from 'jf/common/DevEx';
import { renderReactApp } from 'jf/utils/renderReactApp';

renderReactApp(DevEx, 'devex-container');
